import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LightgalleryProvider } from 'react-lightgallery';

import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../components/NoDataComponent/NoDataComponent';
import { CardsContainer, RoundCircle } from '../../styledComponents/Activity';
import { CommonText, Container } from '../../styledComponents/common';
import {
  ActivityTextSection,
  FlexSection,
} from '../../styledComponents/members';
import SingleCard from './SingleCard';

const CardsList = props => {
  const { isLoading, selfieList, count } = props;
  const { t } = useTranslation();
  const [timeRange, setTimeRange] = useState([]);
  const [counterState, setCounterState] = useState(0)

  useEffect(() => {
    setCounterState(prev => prev + 1)
  },[selfieList]);

  {/* Loading and Zero Data State */}
  if (isLoading) {
    return (
      <Container padding="10px 10px">
        <ComponentCircleLoader />
      </Container>
    )
  }

  return (
    <Container padding="10px 10px">
      {count == 0 && (
        <NoDataComponent
          title={t('no_selfie_image_found')}
          padding="5vh 0"
          imageHeight="140px"
        />
      )}
      <LightgalleryProvider
        key={counterState}
        lightgallerySettings={{
          width: '100%',
          height: '100%',
          hideControlOnEnd: true,
          loop: false,
          download: false,
          hideBarsDelay: 1000,
          mousewheel: true,
        }}
      >
        {selfieList && count > 0 && (
          <CardsContainer key={counterState}>
            {selfieList.map((item, i) => (
              <SingleCard
                selfieItem={item}
                key={i}
                imageId={item.id}
                image={item.selfie}
                timestamp={moment(item.created_at).local().format('h:mm A, Do MMM, YYYY')}
                user={item.employee}
                officeNumber={item.office}
                taskCode={item.task_code}
              />
            ))}
          </CardsContainer>
        )}
      </LightgalleryProvider>
    </Container>
  );
};

export default CardsList;
